import { render, staticRenderFns } from "./ProcessViewer.vue?vue&type=template&id=07dfbc9a&"
import script from "./ProcessViewer.vue?vue&type=script&lang=js&"
export * from "./ProcessViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProcessViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07dfbc9a')) {
      api.createRecord('07dfbc9a', component.options)
    } else {
      api.reload('07dfbc9a', component.options)
    }
    module.hot.accept("./ProcessViewer.vue?vue&type=template&id=07dfbc9a&", function () {
      api.rerender('07dfbc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/designer/ProcessViewer.vue"
export default component.exports